import { useUserActivity } from 'app/components/user-activity/useUserActivity'
import { UserActivityComponent } from 'app/components/user-activity/UserActivityComponent'

export default function UserActivityView() {
  const { activities } = useUserActivity()
  return <UserActivityComponent activities={activities} />
}
